<script>
export default {
  components: { },
  props: {
    slides: {
      type: Array,
      required: false,
      default: () => []
    },
    activeSlide: {
      type: Number,
      required: false,
      default: 0
    },
    goToSlide: {
      type: Function,
      required: false,
      default: () => { return function() {} }
    }
  },
  methods: {
    isActive(index) {
      return index === this.activeSlide;
    },
    isNext(index) {
      return index === this.activeSlide + 1;
    },
    isPrev(index) {
      return index === this.activeSlide - 1;
    },
    itemClasses(index) {
      return [
        this.$style.item,
        this.isActive(index)? this.$style['item--active'] : null,
        this.isNext(index)? this.$style['item--next'] : null,
        this.isPrev(index)? this.$style['item--prev'] : null,
      ]
    },
    slideNumber(index) {
      const number = index + 1;
      return number? number.toString().replace(/^([0-9])$/,'0$1') : '';
    }
  }
}
</script>

<template>
  <nav :class="$style.nav">
    <ol>
      <li v-for="(slide, slideIndex) in slides"  :key="slide.id" :class="itemClasses(slideIndex)" @click="goToSlide(slideIndex)">
        <span>{{slideNumber(slideIndex)}}. {{$t(slide.id + '.title')}}</span>
      </li>
    </ol>
  </nav>
</template>

<style lang="scss" module>
@import '@design';
.nav {
  position: fixed;
  top: 50%;
  right: $size-grid-size * 3;
  display: none;
  transform: translateY(-50%);

  @media screen and (min-width: $size-breakpoint-md) {
    display: block;
  }
}
.item {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  &::after {
    width: 30px;
    height: 2px;
    content: "";
    background: #fff;
    transition: width 0.2s ease-in-out;
  }
  span {
    padding-right: $size-grid-size;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &--next, &--prev {
    &::after {
      width: 38px;
    }
  }
  &:hover:not(&--active) {
    &::after {
      width: 38px;
    }
    span {
      opacity: 1;
    }
  }
  &--active {
    &::after {
      width: 57px;
      background: $color-highlight;
    }
    span {
      opacity: 1;
    }
  }
}
</style>
